import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@progress/kendo-react-buttons';

import CustomCheckbox from './CustomCheckbox';

export default class FilterItemCheckbox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showHiddenItems: false
        };

        this.handleSelectedItem = this.handleSelectedItem.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
    }

    handleSelectedItem (itemId, selected) {
        // this.props.itemSelected(this.props.id, )

        const { filterId, filterSelectionChanged } = this.props;
        filterSelectionChanged(filterId, itemId, selected);
    }

    handleShowMore() {
        this.setState({ showHiddenItems: !this.state.showHiddenItems });
    }

    createItem(id, name, isSelected){
        return (
            <li key={id}>
                <CustomCheckbox itemId={id} onItemSelected={this.handleSelectedItem} isSelected={isSelected}/>
                <label className="k-checkbox-label" htmlFor={id}>{name}</label>
            </li>
        );
    }

    render() {

        const { title, options, allOption, itemsToShow, renderCustomFilter } = this.props;

        if(options.length <= 1) return null;

        let length = itemsToShow ? itemsToShow: options.length;
        
        //This condition will be true if the "Show More" button was clicked.
        if(this.state.showHiddenItems) {
            length = options.length;
        }

        let showMoreButton = null;

        const listItems = [];

        const selectedOptions = this.props.selectedOptions || [];
        for(let index = 0; index < length; index++) {
            const option = options[index];
            const isSelected = selectedOptions.includes(option.id);
            listItems.push(this.createItem(option.id, option.name, isSelected));
        }

        if(allOption) {
            listItems.unshift(this.createItem('all', 'All'));
        }

        if(itemsToShow) {
            const text = this.state.showHiddenItems ? 'Less': 'More';
            const icon = this.state.showHiddenItems ? 'minus': 'plus';
            showMoreButton = <Button icon={icon} onClick={this.handleShowMore} primary={true}>{text}</Button>;
        }

        let customFilter = null;
        if(renderCustomFilter) {
            customFilter = renderCustomFilter();
        }

        return (
            <div className="filter-container">
                <div className="filter-section">
                    <h3>{title}</h3>
                    <div>
                        <ul>
                            {listItems}
                        </ul>
                        {showMoreButton}
                        {customFilter}
                    </div>
                </div>
            </div>
        );

    }

}

FilterItemCheckbox.propTypes = {
    filterId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    selectedOptions: PropTypes.array,
    filterSelectionChanged: PropTypes.func,
    allOption: PropTypes.bool,
    itemsToShow: PropTypes.number,
    renderCustomFilter: PropTypes.func
};